var Search = (function($) {

  var _s = {
    container: '.search-overlay',
    trigger: '.search-trigger',
    search_input: '.search-overlay .search-field'
  };

  var _init = function() {
    _bindEvents();
  };

  var _bindEvents = function() {
    $(document).on('click', _s.trigger, function() {
      $(_s.container).toggleClass('active');
      
      if ( $(_s.container).hasClass('active') ) {
        $(_s.search_input).trigger('focus');
      }
    });
    
  };

  return {
    init: _init
  };

})(jQuery);